//mui
import {Theme} from '@mui/material';

export const MuiBadge = {
	styleOverrides: {
		root: ({theme}: {theme: Theme}) => ({
			'& .MuiBadge-badge': {
				top: '50%',
				right: '50%',
				fontSize: 12,
				lineHeight: '20px',
				fontWeight: 400,
				color: theme.palette.white,
			},
		}),
	},
};
